import { render, staticRenderFns } from "./MenuProduct.vue?vue&type=template&id=64744696&lang=html"
import script from "./MenuProduct.vue?vue&type=script&lang=js"
export * from "./MenuProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports